import { createSlice } from "@reduxjs/toolkit";
import { fetchPendingOrdersReducer } from "../../reducer/dashboard/fetchPendingOrdersReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  pagination: { page: 1, limit: 5, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const pendingOrdersSlice = createSlice({
  name: "pendingOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingOrdersReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPendingOrdersReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.orders || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 5,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchPendingOrdersReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadOrderRequestQueue");
      });
  },
});

export default pendingOrdersSlice.reducer;
